import React from "react";
import { useBnbSelector } from "../../../redux/store";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { ImageFluid } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import { formatSpecificationValue } from "../../../../../../common-deprecated/utils";
import EngineSpecs from "../../toyota/step-engine/EngineSpecs";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Table from "../../../../../../common-deprecated/styles/v2/toyota/globals/Table";
import FuelTypeLabel from "../../../../../../common-deprecated/styles/v2/toyota/components/FuelTypeLabel";
import type { EngineDetailsModalType } from "../../../utils/modalConstants";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { getWLTPLabel, isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { getMotorizationEngineText } from "../../../utils/engineUtils";
import { ModalSubTitle } from "../../toyota/step-engine/styles/Motorization";
import { getEvDisclaimer } from "../../../utils/settings/bnbSettingUtils";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { getEcoTagType } from "../../../../../shared-logic/utils/typedUtils";
import { getCarDBAssetSrcSet } from "../../../../../shared-logic/utils/imageUtils";

const EngineDetailsModal = (props: ModalViewType<EngineDetailsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { fullSpecs, engine, transmission, specs } = modalSettings.motorization;
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const { culture } = commonSettings;

    const ecoTag = getEcoTagType(engine);
    const engineText = getMotorizationEngineText(commonSettings, engine);

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="engineDetails" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Flex.Row mb={engine.image ? 0 : 3}>
                    <Flex.Col width={engine.image ? 3 / 5 : 1} textAlign={isRTL(commonSettings) ? "right" : "left"}>
                        <ModalSubTitle m={0}>
                            {engine.name} <FuelTypeLabel type={ecoTag}>{engineText}</FuelTypeLabel>
                        </ModalSubTitle>
                        <Type.SmallHeading as="p" m={0} pb={3}>
                            {transmission.name}
                        </Type.SmallHeading>
                        <EngineSpecs
                            specs={specs}
                            engineDisclaimer={getWLTPLabel(commonSettings, engine.certification, engine.electric)}
                            electric={engine.electric}
                        />
                    </Flex.Col>
                    {engine.image && (
                        <Flex.Col display={{ xs: "none", md: "flex" }} width={2 / 5}>
                            <ImageFluid
                                {...getCarDBAssetSrcSet(commonSettings, [{ width: 512, height: 512 }], engine.image)}
                                loading="lazy"
                                width="512"
                                height="100%"
                                sizes="512px"
                                alt={engine.name}
                            />
                        </Flex.Col>
                    )}
                </Flex.Row>
                <Table.Base>
                    <Table.TBody>
                        {fullSpecs.map((spec) => (
                            <Table.TR key={spec.id}>
                                <Table.TH width="50%">
                                    {spec.name}
                                    {getEvDisclaimer(bnbSettings, commonSettings, spec.internalCode) && (
                                        <>
                                            {" "}
                                            <Popover
                                                showOnClick
                                                content={
                                                    getEvDisclaimer(bnbSettings, commonSettings, spec.internalCode)!
                                                }
                                                useHTML
                                            />
                                        </>
                                    )}
                                </Table.TH>
                                <Table.TD width="50%" weight="bold">
                                    {formatSpecificationValue(spec.minValue, culture)}
                                    {spec.minValue !== spec.maxValue
                                        ? ` - ${formatSpecificationValue(spec.maxValue, culture)}`
                                        : null}
                                </Table.TD>
                            </Table.TR>
                        ))}
                    </Table.TBody>
                </Table.Base>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default EngineDetailsModal;
